export const animateUp = {
  'data-aos': "fade-up",
  'data-aos-easing': "ease-in-sine",
  'data-aos-offset': "0"
}
export const animateDown = {
  'data-aos': "fade-down",
  'data-aos-easing': "ease-in-sine",
  'data-aos-offset': "0"
}
export const animateLeft = {
  'data-aos': "fade-left",
  'data-aos-easing': "ease-in-sine",
}
export const animateRight = {
  'data-aos': "fade-right",
  'data-aos-easing': "ease-in-sine",
}